module.exports = __webpack_public_path__ + "media/images/patient-icon-nav-hover-1c09e95d1c87a5ef1a0606024d3f6e1f.svg";